<template>
    <div class="navi">
        <router-link v-if='isActive([role.role_admin,role.role_kawagoe])' :to='getLinkTarget("DeviceManagement", "/philips/device/DeviceManagement")'>
            <div :class='getClass("DeviceManagement")'><b-icon icon="devices"/>機器一覧</div>
        </router-link>
        <router-link v-if='isActive([role.role_admin,role.role_kawagoe,role.role_salesOffice])' :to='getLinkTarget("ReturnDelayedManagement", "/philips/device/ReturnDelayedManagement")'>
            <div :class='getClass("ReturnDelayedManagement")'><b-icon icon="restore-alert"/>遅延管理</div>
        </router-link>
        <router-link v-if='isActive([role.role_admin,role.role_kawagoe])' :to='getLinkTarget("DeviceAdd", "/philips/device/DeviceAdd")'>
            <div :class='getClass("DeviceAdd")'><b-icon icon="watch-import-variant"/>機器追加</div>
        </router-link>
        <router-link v-if='isActive([role.role_admin,role.role_kawagoe])' :to='getLinkTarget("DeviceKindManagement", "/philips/device/DeviceKindManagement")'>
            <div :class='getClass("DeviceKindManagement")'><b-icon icon="garage-variant"/>機種管理</div>
        </router-link>
        <router-link
            v-if='isActive([role.role_admin, role.role_headOffice, role.role_salesOffice, role.role_call_center, role.role_headOffice_call])'
            :to='getLinkTarget("CpapFollowUpCallList", "/philips/call/CpapFollowUpCallList")'
        >
            <div :class='getClass("CpapFollowUpCallList")'><b-icon icon="phone-check"/>コール管理</div>
        </router-link>
        <router-link
            v-if='isActive([role.role_admin, role.role_headOffice, role.role_salesOffice, role.role_call_center, role.role_headOffice_call])'
            :to='getLinkTarget("EscalationList", "/philips/escalation/EscalationList")'
        >
            <div :class='getClass("EscalationList")'><b-icon icon="escalator"/>エスカレーション管理</div>
        </router-link>
    </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "DeviceNaviBar",
  props: ["pageid"],
  methods: {
      isActive: function(roles){
          return (roles.indexOf(this.roleId) >= 0);
      },    
      getLinkTarget: function(tabkind, target){
          var ret = target;
          if(tabkind == this.pageid){
              ret = ""
          }
          return ret;
      },
      getClass: function(tabkind) {
          var ret = "tabLabel ";
          if(tabkind == this.pageid){
            ret += "active";
          } else {
            ret += "deactive";
          }
          return ret;
      }

  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    return {
        role: role,
        roleId:roleId,
    };
  },
  filters: {},
  components: {},

};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 194px;
    height: 30px;
    line-height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/DeviceNaviBar.vue